// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"233c92b8","455":"78c5d0f8","977":"7de16a02"}[chunkId] + ".chunk.js";
};